import { z } from 'zod';
import {
  CONTAINS_DIGIT_REGEXP,
  CONTAINS_LOWERCASE_LETTER_REGEXP,
  CONTAINS_SYMBOL_REGEXP,
  CONTAINS_UPPERCASE_LETTER_REGEXP,
  LETTERS_ONLY_LATIN_REGEXP,
  ONLY_LETTERS_REGEXP,
} from '../refinement';
import { maxLengthMessage, minLengthMessage } from './messages';

export const password = z
  .string()
  .min(8, minLengthMessage('Password', 8))
  .max(128, maxLengthMessage('Password', 128))
  .regex(CONTAINS_DIGIT_REGEXP, 'Should contain at least one digit')
  .regex(CONTAINS_SYMBOL_REGEXP, 'Should contain at least one symbol')
  .regex(LETTERS_ONLY_LATIN_REGEXP, 'Only latin letters are allowed')
  .regex(CONTAINS_UPPERCASE_LETTER_REGEXP, 'Should contain at least one uppercase letter')
  .regex(CONTAINS_LOWERCASE_LETTER_REGEXP, 'Should contain at least one lowercase letter');

export const onlyLatinLetters = z.string().regex(ONLY_LETTERS_REGEXP, 'Please use latin letters');

export const email = z.string().email('Please enter valid email');
